export default class OnHandConfigModel {
    constructor(context, display, router) {
        this.context = context;
        this.display = display;
        this.router = router;
    }
}
